<template>
  <el-select clearable @change="handleChange" :value="data" placeholder="请选择" :disabled="disable">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in list" :key="index"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "BatteryType",
    props: {
      value: {},
      disable: {
        default: false,
        type: Boolean
      }
   },
     watch: {
      value: {
        immediate: true,
        handler: function(value) {
          this.data = value;
        }

      },

    },
    data() {
      return {
        data: "",
        list: [{
            name: "电池包",
            value: 1
          },
          {
            name: "电池模块",
            value: 2
          },
          {
            name: "电池单体",
            value: 3
          }
        ]
      }
    },
    methods: {
      handleChange(value) {
        this.data = value;
        this.$emit("input", value)
      }
    }
  }
</script>

<style scoped>

</style>
